import axios from 'axios'

let _svc
let _that

export default {
  // Administratie
  GetAdministratieFacturen: () => {
    try {
      return _svc.get('Klant/LoggedIn/Administratie/Factuur/List')
    } catch {
      return null
    }
  },

  // Code
  GetCodeList: (codeType) => {
    try {
      return _svc.get(`Klant/LoggedIn/Code/List/${codeType}`)
    } catch {
      return null
    }
  },

  // Contact
  SendContactBericht: (contactBericht) => {
    try {
      return _svc.post('Klant/LoggedOut/Contact/Bericht/Send', contactBericht)
    } catch {
      return null
    }
  },

  // Enquete
  GetEnqueteListKlant: () => {
    try {
      return _svc.get('Klant/LoggedIn/Enquete/List/Klant')
    } catch {
      return null
    }
  },
  GetEnqueteListVraagGroep: (idKlant) => {
    try {
      return _svc.get(`Klant/LoggedIn/Enquete/List/VraagGroep/${idKlant}`)
    } catch {
      return null
    }
  },
  SaveEnquete: (enquete) => {
    try {
      return _svc.post('Klant/LoggedIn/Enquete/Save', enquete)
    } catch {
      return null
    }
  },

  // General
  GetDossier: () => {
    try {
      return _svc.get('Klant/Loggedin/Dossier')
    } catch {
      return null
    }
  },

  // Opvolging
  GetDossierOpvolgingFamilieTaakList: (idDossier) => {
    try {
      return _svc.get(`Opvolging/DossierOpvolgingFamilieTaakList/${idDossier}`)
    } catch {
      return null
    }
  },

  // NieuwsList
  GetNieuwsList: () => {
    try {
      return _svc.get('Klant/LoggedOut/Nieuws')
    } catch {
      return null
    }
  },

  // OverlijdensberichtList
  GetOverlijdensberichtList: () => {
    try {
      return _svc.get('Klant/LoggedOut/OverlijdensberichtList')
    } catch {
      return null
    }
  },
  GetOverlijdensberichtListListFiliaal: () => {
    try {
      return _svc.get('Klant/LoggedOut/OverlijdensberichtList/List/Filiaal')
    } catch {
      return null
    }
  },

  // OverlijdensberichtDetail
  GetOverlijdensberichtDetailKoffietafelListPost: () => {
    try {
      return _svc.get('Klant/LoggedOut/OverlijdensberichtDetail/Koffietafel/List/Post')
    } catch {
      return null
    }
  },
  GetOverlijdensberichtDetailLivestream: (idDossier, code) => {
    try {
      return _svc.get(`Klant/LoggedOut/OverlijdensberichtDetail/Livestream/Hyperlink/${idDossier}/${code}`)
    } catch {
      return null
    }
  },
  GetOverlijdensberichtDetailThumbnail: (id) => {
    try {
      return _svc.get(`Klant/LoggedOut/OverlijdensberichtDetail/Thumbnail/${id}`)
    } catch {
      return null
    }
  },
  SaveOverlijdensberichtDetailCondoleren: (overlijdensberichtDetailCondoleren) => {
    try {
      return _svc.post('Klant/LoggedOut/OverlijdensberichtDetail/Condoleren/Save', overlijdensberichtDetailCondoleren)
    } catch {
      return null
    }
  },
  SaveOverlijdensberichtDetailKoffietafel: (overlijdensberichtDetailKoffietafel) => {
    try {
      return _svc.post('Klant/LoggedOut/OverlijdensberichtDetail/Koffietafel/Save', overlijdensberichtDetailKoffietafel)
    } catch {
      return null
    }
  },

  // Uitvaart
  GetUitvaartCondoleanceList: () => {
    try {
      return _svc.get('Klant/LoggedIn/Uitvaart/CondoleanceList')
    } catch {
      return null
    }
  },
  GetUitvaartDraaiboek: () => {
    try {
      return _svc.get('Klant/LoggedIn/Uitvaart/Draaiboek')
    } catch {
      return null
    }
  },
  GetUitvaartDraaiboekKernwoorden: () => {
    try {
      return _svc.get('Klant/LoggedIn/Uitvaart/Draaiboek/Kernwoorden')
    } catch {
      return null
    }
  },
  SaveUitvaartDraaiboekKernwoorden: (kernwoorden) => {
    try {
      return _svc.post('Klant/LoggedIn/Uitvaart/Draaiboek/Kernwoorden/Save', kernwoorden)
    } catch {
      return null
    }
  },
  GetUitvaartDraaiboekListCode: () => {
    try {
      return _svc.get('Klant/LoggedIn/Uitvaart/Draaiboek/List/Code')
    } catch {
      return null
    }
  },
  GetUitvaartSymboliek: () => {
    try {
      return _svc.get('Klant/LoggedIn/Uitvaart/Symboliek')
    } catch {
      return null
    }
  },
  GetUitvaartFacturatieList: () => {
    try {
      return _svc.get('Klant/LoggedIn/Uitvaart/FacturatieList')
    } catch {
      return null
    }
  },
  GetUitvaartGedichtList: () => {
    try {
      return _svc.get('Klant/LoggedIn/Uitvaart/Gedicht/List')
    } catch {
      return null
    }
  },
  GetUitvaartGrafmonumentenList: () => {
    try {
      return _svc.get('Klant/LoggedIn/Uitvaart/Grafmonument/List')
    } catch {
      return null
    }
  },
  GetUitvaartKoffietafelInschrijvingList: () => {
    try {
      return _svc.get('Klant/LoggedIn/Uitvaart/KoffietafelInschrijvingList')
    } catch {
      return null
    }
  },
  GetUitvaartMuziek: () => {
    try {
      return _svc.get('Klant/LoggedIn/Uitvaart/Muziek')
    } catch {
      return null
    }
  },
  GetUitvaartMuziekListCode: () => {
    try {
      return _svc.get('Klant/LoggedIn/Uitvaart/Muziek/List/Code')
    } catch {
      return null
    }
  },
  GetUitvaartMuziekListMuziek: () => {
    try {
      return _svc.get('Klant/LoggedIn/Uitvaart/Muziek/List/Muziek')
    } catch {
      return null
    }
  },
  GetUitvaartOverlijdensberichtPublicatieList: () => {
    try {
      return _svc.get('Klant/LoggedIn/Uitvaart/OverlijdensberichtPublicatieList')
    } catch {
      return null
    }
  },
  GetUitvaartPrentjeTekstList: () => {
    try {
      return _svc.get('Klant/LoggedIn/Uitvaart/Prentje/Tekst/List')
    } catch {
      return null
    }
  },
  GetUitvaartRouwbriefhoofdingList: () => {
    try {
      return _svc.get('Klant/LoggedIn/Uitvaart/Rouwbrief/Hoofding/List')
    } catch {
      return null
    }
  },
  GetUitvaartTekstenDetail: (id) => {
    try {
      return _svc.get(`Klant/LoggedIn/Uitvaart/Tekst/${id}`)
    } catch {
      return
    }
  },
  GetUitvaartTekstenList: () => {
    try {
      return _svc.get('Klant/LoggedIn/Uitvaart/Tekst/List')
    } catch {
      return null
    }
  },
  SaveUitvaartDraaiboek: (uitvaartDraaiboek) => {
    try {
      return _svc.post('Klant/LoggedIn/Uitvaart/Draaiboek/Save', uitvaartDraaiboek)
    } catch {
      return null
    }
  },
  GetUitvaartFotos: () => {
    try {
      return _svc.get('Klant/LoggedIn/Uitvaart/Draaiboek/Fotos')
    } catch {
      return null
    }
  },
  GetUitvaartTekstenVolgorde: () => {
    try {
      return _svc.get('Klant/LoggedIn/Uitvaart/Draaiboek/TekstenVolgorde')
    } catch {
      return null
    }
  },
  GetUitvaartLevensverhaal: () => {
    try {
      return _svc.get('Klant/LoggedIn/Uitvaart/Draaiboek/Levensverhaal')
    } catch {
      return null
    }
  },
  SaveUitvaartLevensverhaal: (levensverhaal) => {
    try {
      return _svc.post('Klant/LoggedIn/Uitvaart/Draaiboek/Levensverhaal/Save', levensverhaal)
    } catch {
      return null
    }
  },
  SaveUitvaartFotos: (fotos) => {
    try {
      return _svc.post('Klant/LoggedIn/Uitvaart/Draaiboek/Fotos/Save', fotos)
    } catch {
      return null
    }
  },
  GetUitvaartExtraOpmerkingen: () => {
    try {
      return _svc.get('Klant/LoggedIn/Uitvaart/Draaiboek/ExtraOpmerkingen')
    } catch {
      return null
    }
  },
  SaveUitvaartExtraOpmerkingen: (extraOpmerkingen) => {
    try {
      return _svc.post('Klant/LoggedIn/Uitvaart/Draaiboek/ExtraOpmerkingen/Save', extraOpmerkingen)
    } catch {
      return null
    }
  },
  SaveUitvaartTekstenVolgorde: (tekstenVolgorde) => {
    try {
      return _svc.post('Klant/LoggedIn/Uitvaart/Draaiboek/TekstenVolgorde/Save', tekstenVolgorde)
    } catch {
      return null
    }
  },
  SaveUitvaartSymboliek: (symboliek) => {
    try {
      return _svc.post('Klant/LoggedIn/Uitvaart/Symboliek/Save', symboliek)
    } catch {
      return null
    }
  },
  SaveUitvaartMuziek: (uitvaartMuziek) => {
    try {
      return _svc.post('Klant/LoggedIn/Uitvaart/Muziek/Save', uitvaartMuziek)
    } catch {
      return null
    }
  },
  SaveUitvaartPrentjeTekst: (uitvaartPrentjeTekst) => {
    try {
      return _svc.put('Klant/LoggedIn/Uitvaart/Prentje/Tekst/Save', uitvaartPrentjeTekst)
    } catch {
      return null
    }
  },
  SaveUitvaartRouwbriefhoofding: (uitvaartRouwbriefhoofding) => {
    try {
      return _svc.put('Klant/LoggedIn/Uitvaart/Rouwbrief/Hoofding/Save', uitvaartRouwbriefhoofding)
    } catch {
      return null
    }
  },
  SaveUitvaartTeksten: (uitvaartTeksten) => {
    try {
      return _svc.put('Klant/LoggedIn/Uitvaart/Tekst/List/Save', uitvaartTeksten)
    } catch {
      return null
    }
  },
  SelecteerUitvaartGrafmonument: (id) => {
    try {
      return _svc.post(`Klant/LoggedIn/Uitvaart/Grafmonument/Save/${id}`)
    } catch {
      return null
    }
  },
  SendUitvaartCondoleanceListAntwoord: (uitvaartCondoleanceAntwoord) => {
    try {
      return _svc.post('Klant/LoggedIn/Uitvaart/CondoleanceList/Antwoord', uitvaartCondoleanceAntwoord)
    } catch {
      return null
    }
  },

  // Webshop
  GetWebshopListCode: () => {
    try {
      return _svc.get('Klant/LoggedOut/Webshop/List/Code')
    } catch {
      return null
    }
  },
  GetWebshopListPost: () => {
    try {
      return _svc.get('Klant/LoggedOut/Webshop/List/Post')
    } catch {
      return null
    }
  },
  GetWebshopListProduct: (webshopType, loggedIn) => {
    try {
      return _svc.get(`Klant/${loggedIn ? 'LoggedIn' : 'LoggedOut'}/Webshop/List/Product/${webshopType}`)
    } catch {
      return null
    }
  },
  GetWebshopThumbnail: (id) => {
    try {
      return _svc.get(`Klant/LoggedOut/Webshop/Thumbnail/${id}`)
    } catch {
      return null
    }
  },
  SaveWebshopFacturatie: (webshopFacturatie) => {
    try {
      return _svc.post('Klant/LoggedOut/Webshop/Save', webshopFacturatie)
    } catch {
      return null
    }
  },

  // Other
  Init: (that) => {
    _that = that

    _svc = axios.create({
      baseURL: process.env.VUE_APP_API_URL
    })

    _svc.interceptors.response.use(
      response => response,
      error => {
        _that.ErrorMixin_HandleError(error)
      }
    )
  }
}
